import { DollarSign, Phone, Shield, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Hero = ({ onOpenForm, onOpenContact }) => {
  const scrollToHow = () =>
    document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="pt-24 md:pt-32 pb-16 md:pb-24 bg-[#F5F5F0]" data-testid="hero-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 space-y-6 animate-fade-in-up">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1] text-[#1F2937]" style={{ fontFamily: "Manrope" }} data-testid="hero-h1">
              Sell Diabetic Test Strips &amp; Supplies for Cash in Jacksonville
            </h1>

            <h2 className="text-xl md:text-2xl font-semibold text-[#0F5132]" style={{ fontFamily: "Manrope" }} data-testid="hero-h2-buyer">
              Jacksonville&apos;s Trusted Diabetic Supplies Buyer
            </h2>

            {/* Clarification box */}
            <div className="bg-[#0F5132]/5 border-l-4 border-[#0F5132] rounded-lg p-4" data-testid="hero-clarification-box">
              <p className="text-[#1F2937] font-semibold text-base md:text-lg leading-relaxed">
                Are you looking to sell your extra, unused diabetic supplies? We provide local, same-day cash payouts for unopened items. <span className="text-[#4B5563] font-medium">Note: We are a private buyer, not a retail pharmacy.</span>
              </p>            </div>

            <p className="text-xl md:text-2xl font-semibold text-[#1F2937] mb-2">
              We Buy Test Strips, Dexcom G7, & More for Instant Cash
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-[#4B5563]">
              <span className="font-semibold text-[#1F2937]">We Come to You! Same-Day Mobile Meetups anywhere in Jacksonville.</span>{" "}
              We meet at safe, public locations convenient for you—whether it&apos;s a Wawa, Starbucks, or your local grocery store parking lot.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={onOpenForm}
                className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all hover:-translate-y-0.5"
                data-testid="hero-sell-btn"
              >
                Get Your Offer
              </Button>
              <Button
                variant="outline"
                onClick={scrollToHow}
                className="rounded-full px-8 py-6 text-lg font-medium border-2 border-[#0F5132] text-[#0F5132] hover:bg-[#0F5132]/5"
                data-testid="hero-learn-btn"
              >
                Learn How It Works
              </Button>
            </div>

            <button
              onClick={onOpenContact}
              className="inline-flex items-center gap-3 bg-[#1F2937] hover:bg-black text-white rounded-2xl px-6 py-4 font-bold text-lg shadow-xl transition-all hover:-translate-y-1 hover:shadow-2xl border-2 border-[#EA580C]"
              data-testid="hero-text-cta"
            >
              <div className="flex items-center justify-center w-10 h-10 bg-[#EA580C] rounded-full">
                <MessageCircle className="w-5 h-5" />
              </div>
              <span>Text a Photo or Call for Instant Cash Offer</span>
              <Phone className="w-5 h-5" />
            </button>

            <div className="flex items-center gap-2 text-sm text-[#4B5563]">
              <Shield className="w-5 h-5 text-[#0F5132]" />
              <span>Secure & Confidential</span>
            </div>
          </div>
          <div className="lg:col-span-7 animate-fade-in-up animation-delay-200">
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/5790828/pexels-photo-5790828.jpeg"
                alt="Sell diabetic test strips for cash in Jacksonville FL - Same day payment for Dexcom G7 and diabetes supplies"
                className="rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]"
                data-testid="hero-image"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-lg hidden md:flex items-center gap-3">
                <div className="w-12 h-12 bg-[#0F5132]/10 rounded-full flex items-center justify-center">
                  <DollarSign className="w-6 h-6 text-[#0F5132]" />
                </div>
                <div>
                  <p className="text-xl font-bold text-[#1F2937]" style={{ fontFamily: "Manrope" }}>Lightning-Fast Payouts</p>
                  <p className="text-sm text-[#4B5563]">Same day cash!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
